import { motion } from "framer-motion";
import { twMerge } from "tailwind-merge";

export function Reveal({ children, delay = 0, y = 40, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function Label({ children, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.25em] text-gold ${className}`}>
      <span className="w-6 h-px bg-gold" />{children}
    </span>
  );
}

export const BOOKING_URL = "https://hfc.pushpress.com/landing/plans/plan_4e2ffb14ee9a48";
export const INTERESTED_URL = "https://hfc.pushpress.com/open/interested";

export function BookButton({ children = "Start Your Free Intro", className = "", testid = "book-cta", href = BOOKING_URL }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      className={twMerge(`group inline-flex items-center justify-center rounded-full bg-gold text-black font-bold px-8 py-4 hover:bg-white transition-colors duration-300 ${className}`)}
    >
      {children}
    </a>
  );
}

export function Marquee({ items, reverse = false }) {
  const row = [...items, ...items];
  return (
    <div className="relative overflow-hidden py-6 border-y border-white/10 bg-black">
      <div className={`marquee-track ${reverse ? "reverse" : ""}`}>
        {row.map((it, i) => (
          <span key={i} className="mx-8 font-display text-4xl md:text-6xl uppercase text-outline flex items-center gap-8">
            {it}<span className="text-gold text-3xl">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
